import { isAccommodationV2Item } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'
import { createSelector } from 'reselect'

const getAccommodationV2Items = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): Array<App.Checkout.AccommodationV2Item> => items.filter(isAccommodationV2Item),
  reselectShallowEqual,
)

export default getAccommodationV2Items
